import React from 'react';
export function TerroirSection() {
  return <section className="bg-charcoal min-h-[600px] flex flex-col lg:flex-row overflow-hidden" data-id="element-166">
      {/* Image Side - Parallax */}
      <div className="w-full lg:w-1/2 h-[400px] lg:h-auto relative overflow-hidden" data-id="element-167">
        <img src="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/DJI_0231.jpg" alt="Aerial view of Glenlofty vineyard" className="absolute inset-0 w-full h-full object-cover" data-id="element-168" />
        {/* Overlay for consistency */}
        <div className="absolute inset-0 bg-black/10" data-id="element-169"></div>
      </div>

      {/* Content Side */}
      <div className="w-full lg:w-1/2 py-[60px] md:py-[80px] lg:py-[120px] px-6 md:px-12 lg:px-20 flex flex-col justify-center" data-id="element-170">
        <span className="text-label uppercase tracking-wide-label mb-6 block font-light text-gold" data-id="element-171">
          OUR VINEYARD
        </span>

        <h2 className="md:text-section-tablet lg:text-section-desktop text-white mb-8 font-[500]" data-id="element-172">
          Cool-Climate Pyrenees
        </h2>

        <p className="text-body text-white/90 mb-10" data-id="element-173">
          Located approximately 1,000 feet above sea level in the Pyrenees
          foothills, Glenlofty is a true cool-climate site by Australian
          standards. Significant diurnal variation preserves acidity and
          structure. Independent AWRI data identifies Glenlofty as one of the
          coolest sites in the Pyrenees.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-8 border-t border-white/20 pt-8" data-id="element-174">
          <div className="text-white/90 text-lg font-optima" data-id="element-175">
            ~140 hectares under vine
          </div>
          <div className="text-white/90 text-lg font-optima" data-id="element-176">
            30 individual vineyard blocks
          </div>
          <div className="text-white/90 text-lg font-optima" data-id="element-177">
            Low yields: 4–5 tonnes/hectare
          </div>
          <div className="text-white/90 text-lg font-optima" data-id="element-178">
            Certified organic
          </div>
        </div>
      </div>
    </section>;
}